var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _style;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCircleAnimation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 291,
    height: 448,
    viewBox: "0 0 291 448",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    style: {},
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M-55 277.5C-55 197.712 9.71215 133 89.5 133C169.288 133 234 197.712 234 277.5C234 357.288 169.288 422 89.5 422",
    stroke: "#EF767A",
    strokeWidth: 50.8477,
    strokeMiterlimit: 10,
    className: "DQhbfwmX_0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M209.466 0H201.213V170.678H209.466V0Z",
    fill: "#B89365",
    className: "DQhbfwmX_1"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M290.678 81.2124H120V89.4657H290.678V81.2124Z",
    fill: "#B89365",
    className: "DQhbfwmX_2"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M147.898 22.0713L142.062 27.9072L262.749 148.593L268.585 142.758L147.898 22.0713Z",
    fill: "#B89365",
    className: "DQhbfwmX_3"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M262.749 22.0705L142.062 142.757L147.898 148.593L268.585 27.9064L262.749 22.0705Z",
    fill: "#B89365",
    className: "DQhbfwmX_4"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M127.887 49.3464L124.773 56.9897L282.838 121.386L285.952 113.743L127.887 49.3464Z",
    fill: "#B89365",
    className: "DQhbfwmX_5"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M233.742 4.78535L169.346 162.85L176.989 165.964L241.386 7.89931L233.742 4.78535Z",
    fill: "#B89365",
    className: "DQhbfwmX_6"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M283.025 49.6336L124.688 113.365L127.769 121.021L286.107 57.2902L283.025 49.6336Z",
    fill: "#B89365",
    className: "DQhbfwmX_7"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M177.256 4.69151L169.6 7.77246L233.314 166.11L240.97 163.029L177.256 4.69151Z",
    fill: "#B89365",
    className: "DQhbfwmX_8"
  })), _style || (_style = /*#__PURE__*/React.createElement("style", {
    "data-made-with": "vivus-instant"
  }, ".DQhbfwmX_0{stroke-dasharray:682 684;stroke-dashoffset:683;animation:DQhbfwmX_draw 3333ms linear 0ms forwards;}.DQhbfwmX_1{stroke-dasharray:358 360;stroke-dashoffset:359;animation:DQhbfwmX_draw 3333ms linear 208ms forwards;}.DQhbfwmX_2{stroke-dasharray:358 360;stroke-dashoffset:359;animation:DQhbfwmX_draw 3333ms linear 416ms forwards;}.DQhbfwmX_3{stroke-dasharray:358 360;stroke-dashoffset:359;animation:DQhbfwmX_draw 3333ms linear 625ms forwards;}.DQhbfwmX_4{stroke-dasharray:358 360;stroke-dashoffset:359;animation:DQhbfwmX_draw 3333ms linear 833ms forwards;}.DQhbfwmX_5{stroke-dasharray:358 360;stroke-dashoffset:359;animation:DQhbfwmX_draw 3333ms linear 1041ms forwards;}.DQhbfwmX_6{stroke-dasharray:358 360;stroke-dashoffset:359;animation:DQhbfwmX_draw 3333ms linear 1250ms forwards;}.DQhbfwmX_7{stroke-dasharray:358 360;stroke-dashoffset:359;animation:DQhbfwmX_draw 3333ms linear 1458ms forwards;}.DQhbfwmX_8{stroke-dasharray:358 360;stroke-dashoffset:359;animation:DQhbfwmX_draw 3333ms linear 1666ms forwards;}@keyframes DQhbfwmX_draw{100%{stroke-dashoffset:0;}}@keyframes DQhbfwmX_fade{0%{stroke-opacity:1;}95.65217391304348%{stroke-opacity:1;}100%{stroke-opacity:0;}}")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircleAnimation);
export default __webpack_public_path__ + "static/media/circle-animation.0f6de22baa00ac89e0179f4fbab41c9d.svg";
export { ForwardRef as ReactComponent };